import { Link } from "react-router-dom";
import { cmsStrings } from "../terminology";

type Crumb = {
  label: string;
  to?: string;
};

type Props = {
  items: Crumb[];
};

export function Breadcrumb({ items }: Props) {
  if (items.length === 0) return null;

  return (
    <nav className="breadcrumb" aria-label={cmsStrings.shell.breadcrumbAria}>
      <ol className="breadcrumb__list">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="breadcrumb__item">
              {index > 0 && (
                <span className="breadcrumb__sep" aria-hidden="true">
                  /
                </span>
              )}
              {last || !item.to ? (
                <span className="breadcrumb__current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="breadcrumb__link">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
